import React, { useEffect, useMemo } from 'react';
import { setSelectedView, getFilteredAssets } from '@/store/slices/assetsPreviewSlice';
import { RootState } from '@/store/store';
import { useDispatch, useSelector } from 'react-redux';
import {
  ASSETS_PREVIEW_INNER_TABS,
  ASSETS_TYPE,
  FILTER_PARAMS,
  PORTAL_TARGETS,
} from '@/types/shared/navigation-tabs.enums';
import { useFetchAssets, useAssetsData, useViewportWidth, useAppFilters, useHasRole } from '@/hooks';
import { useTranslation } from 'react-i18next';
import { BaseTabs } from '@/modules';
import { Overview } from './AssetsOverview/AssetPreviewTabsViews/Overview';
import { Faults } from './AssetsOverview/AssetPreviewTabsViews/Faults/Faults';
import { Experts } from './AssetsOverview/AssetPreviewTabsViews/Experts';
import { MANAGEMENT_ROLE } from '@/const';

export const AssetsOverview = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { currentFiltersValues } = useSelector((state: RootState) => state.assetsPreview);
  const { isMobile } = useViewportWidth();
  const { assets } = useFetchAssets();
  const { assetsType } = useAppFilters();
  const { hasRole: isAdminOrExpert } = useHasRole([
    MANAGEMENT_ROLE.Admin,
    MANAGEMENT_ROLE.DM_Admin,
    MANAGEMENT_ROLE.DM_Expert,
  ]);

  const { required, notRequired } = useAssetsData(assets);
  console.log('currentFiltersValues', currentFiltersValues);

  const [requireAttention, notRequireAttention] = useMemo(() => {
    const applyFilter = (data: any) =>
      assetsType === ASSETS_TYPE.MOBILE
        ? currentFiltersValues
          ? getFilteredAssets(data?.mobile || [], currentFiltersValues, assetsType)
          : null
        : currentFiltersValues
        ? getFilteredAssets(data?.fixed || [], currentFiltersValues, assetsType)
        : null;

    return [applyFilter(required), applyFilter(notRequired)];
  }, [assetsType, currentFiltersValues, required, notRequired, assets]);

  const tableAssets = [];
  if (requireAttention?.length) {
    tableAssets.push(...requireAttention);
  }
  if (notRequireAttention?.length) {
    tableAssets.push(...notRequireAttention);
  }

  useEffect(() => {
    dispatch(setSelectedView('grid'));
  }, [isMobile]);

  const sitesPageTabs = useMemo(() => {
    const tabs = [
      {
        id: ASSETS_PREVIEW_INNER_TABS.OVERVIEW,
        title: 'Overview',
        element: <Overview />,
      },
      {
        id: ASSETS_PREVIEW_INNER_TABS.FAULTS,
        title: 'Faults',
        element: <Faults />,
      },
    ];

    // if (isAdminOrExpert) {
    //   tabs.push({
    //     id: ASSETS_PREVIEW_INNER_TABS.EXPERTS,
    //     title: 'Experts',
    //     element: <Experts />,
    //   });
    // }

    return tabs;
  }, [isAdminOrExpert]);

  return (
    <BaseTabs
      tabs={sitesPageTabs}
      defaultValue={sitesPageTabs[0].id}
      paramAlias={FILTER_PARAMS.ASSETS_SECTION}
      hideTabTriggers={false}
      renderTabListInto={PORTAL_TARGETS.ASSETS_PREVIEW_TABS_CONTAINER}
      variant="secondary-plain"
      classNames={{
        tabList: { container: 'rounded-lg' },
      }}
    />
  );
};
